module.exports = __webpack_public_path__ + "static/lightning-breadcrumb-overflow-c6969f1bdafeedb5ceb03f9c3b4f7ae6.png";